export default "__VITE_ASSET__e2d5c9b9__"